import React, { useEffect, useState } from 'react';
import Header from './../Header/Header';
import Footer from './../Footer/Footer';
import ImportantMessages from './../ImportantMessages/ImportantMessagesContainer';
import env from '../../env';
import ErrorBoundary from 'app/components/ErrorHandler/ErrorBoundary';
import { ReactBase, MainContent, A11yAnnouncer } from './BaseLayout.styles';
import { useRouter } from 'next/router';
import { ReactHelmetPlayApplication } from '../ApplicationHandler/ReactHelmet';
import SurveyContainer from 'app/components/Survey/SurveyContainer';
import GlobalStyles from './GlobalStyles';
import { SlashTiming } from 'app/ui-components/design-tokens';

type Props = {
    mainClassName?: string;
    children: any;
    videoModalOpen: boolean;
};

const BaseLayout = ({ children }) => {
    const router = useRouter();
    const videoModalOpen = Boolean(router.query.modalId);
    const hasCookie =
        typeof document !== 'undefined' &&
        document.cookie.split(';').some((item) => item.trim().startsWith('svt-cookies-information'));

    const [hideOverflow, setHideOverflow] = useState(false);

    useEffect(() => {
        if (videoModalOpen) {
            const handler = setTimeout(() => {
                setHideOverflow(true);
            }, SlashTiming * 0.7);
            return () => {
                clearTimeout(handler);
            };
        } else {
            setHideOverflow(false);
        }
    }, [videoModalOpen]);

    return (
        <>
            <GlobalStyles hideOverflow={hideOverflow} />
            <ReactBase videoModalOpen={videoModalOpen} aria-hidden={videoModalOpen}>
                <ReactHelmetPlayApplication router={router} />
                <A11yAnnouncer id="play_a11y-announcer" aria-live="assertive" />
                <div id="fb-root" data-appid={env.FB_APP_ID}></div>
                <div className={'play_root-container'}>
                    <ImportantMessages />
                    <div className="play_root">
                        <Header />
                        {hasCookie && <SurveyContainer />}
                        <ErrorBoundary>
                            <MainContent id="play_main-content" tabIndex="-1">
                                {children}
                            </MainContent>
                        </ErrorBoundary>

                        <Footer />
                    </div>
                </div>
            </ReactBase>
        </>
    );
};

export const BaseLayoutWrapper = ({ children, videoModalOpen }) => {
    return (
        <ReactBase videoModalOpen={videoModalOpen} aria-hidden={videoModalOpen}>
            {children}
        </ReactBase>
    );
};

export default BaseLayout;
